import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { MessageCircle, Pencil } from "lucide-react";

const ST = { confirmed: "bg-emerald-100 text-emerald-800", enquiry: "bg-sky-100 text-sky-800", visited: "bg-stone-200 text-stone-700", waiting: "bg-amber-100 text-amber-800", completed: "bg-stone-200 text-stone-700" };

export function TimeSlots({ slots, active, onPick }) {
  return (
    <div className="bi-panel" data-testid="bi-time-slots">
      <h2 className="bi-panel-title">Bookings by Time</h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-2">
        {slots.map((s) => (
          <button key={s.slot} type="button" onClick={() => onPick(active === s.slot ? "" : s.slot)}
            className={`rounded-xl border-2 p-3 text-left transition-colors ${active === s.slot ? "border-[#7a0f1d] bg-[#7a0f1d] text-[#fff3c4]" : s.count ? "border-[#e2b85a] bg-[#fff3d6]" : "border-stone-200 bg-white"}`} data-testid={`bi-slot-${s.slot.replace(/[^0-9A-Z]/gi, "")}`}>
            <div className="text-sm font-semibold">{s.slot}</div>
            <div className="text-lg font-bold">{s.count} booking{s.count === 1 ? "" : "s"}</div>
            <div className="text-sm opacity-80">{s.guests} guests</div>
          </button>))}
      </div>
    </div>
  );
}

export function BookingRows({ rows, onWhatsApp, onEdit, slot }) {
  return (
    <div className="bi-panel" data-testid="bi-booking-rows">
      <h2 className="bi-panel-title">{slot ? `Bookings ${slot}` : "Bookings for this date"}</h2>
      {!rows?.length ? <p className="text-base text-muted-foreground">No bookings.</p> : (
        <div className="space-y-2">
          <div className="hidden md:grid grid-cols-[150px_1fr_80px_100px_120px_120px] gap-3 px-3 text-sm font-semibold text-[#7a0f1d]"><span>Time</span><span>Guest</span><span>Guests</span><span>Table</span><span>Status</span><span /></div>
          {rows.map((b) => (
            <div key={b.booking_id} className="grid grid-cols-2 md:grid-cols-[150px_1fr_80px_100px_120px_120px] items-center gap-3 rounded-xl bg-white p-3 text-base shadow-sm" data-testid={`bi-booking-row-${b.booking_id}`}>
              <span className="font-semibold">{b.time_slot}</span>
              <span><b>{b.guest_name}</b><span className="block text-sm text-muted-foreground">{b.phone} · {b.center}</span></span>
              <span>{b.num_guests} pax</span>
              <span>{b.table_allotted || "—"}</span>
              <span><Badge className={ST[String(b.status).toLowerCase()] || "bg-stone-100"}>{b.status}</Badge></span>
              <span className="flex gap-1">
                <Button size="icon" variant="outline" className="h-11 w-11 text-green-700" onClick={() => onWhatsApp(b)} data-testid={`bi-row-wa-${b.booking_id}`}><MessageCircle className="h-5 w-5" /></Button>
                <Button size="icon" variant="outline" className="h-11 w-11" onClick={() => onEdit(b)} data-testid={`bi-row-edit-${b.booking_id}`}><Pencil className="h-5 w-5" /></Button>
              </span>
            </div>))}
        </div>)}
    </div>
  );
}
